export default "images/menu.png";